<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 col-gap-12 row-gap-11 items-start">
    <div class="lg:col-span-2 flex items-center">
      <div class="text-xl font-bold text-text leading-tight ">{{ $t('formTitle') }}</div>
    </div>
    <BaseInput v-model.trim="$v.email.$model"
               :label="$t('emailLabel')"
               :class="{'--error':$v.email.$error }">
      <template v-slot:errors="">
        <div class="error" v-if="!$v.email.required">{{ $t('errors.required') }}</div>
        <div class="error" v-if="!$v.email.email">{{ $t('errors.emailIncorrect') }}</div>
      </template>
    </BaseInput>
    <BaseSelect
        v-model="role"
        :options="rolesList"
        label="name"
        class="col-start-1"
        :select-label="$t('roleLabel')"
        :searchable="false"
        :show-labels="false"
        @input="handleRole"/>
    <div class="self-center text-text-ternary text-sm w-3/4">
      {{ roleTip }}
    </div>
    <div class="lg:col-span-2">
      <BaseButton @click="send"
                  theme="red"
                  :loading="submitted"
                  class="lg:w-91">
        {{ $t('createInvite') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {required, email, helpers} from 'vuelidate/lib/validators'
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseButton from "@/components/UI/BaseButton";

const noSpecSymbols = helpers.regex('noSpecSymbols', /^[^*|\/":<>[\]{}`\\()';@&!$]+$/)

export default {
  name: "AccessSettingsForm",
  components: {
    BaseButton,
    BaseSelect,
    BaseInput,
  },
  data() {
    return {
      submitted: false,
      email: '',
      role: null,
    }
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapGetters('cabinet/constants', ['getConstantList']),
    rolesList() {
      return this.getConstantList('member_role')
    },
    roleTip() {
      switch (+this.role.id) {
        case 0:
          return this.$t('roleViewerTip')
        case 1:
          return this.$t('roleUserTip')
        case 2:
          return this.$t('roleAdminTip')
      }
    }
  },
  validations: {
    email: {
      required,
      email
    },
  },
  methods: {
    ...mapActions('space/access', ['sendInvite']),
    ...mapActions('cabinet/invitations', ['getSentInvitations']),
    handleRole(val) {
      this.role = val;
    },
    send() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitted = true;
        let data = {
          space_id: this.user_info.data.space_id,
          email: this.email,
          role: this.role.id
        };
        this.sendInvite(data).then(res => {
          if (res.body.success) {
            this.getSentInvitations();
            this.email = '';
            this.role = this.rolesList[0];
            this.$v.$reset();
            this.$toasted.success('Приглашение отправлено')
          } else {
            console.log(res)
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.submitted = false;
        });
      } else {
        this.$toasted.error('Проверьте поля')
        this.submitted = false;
      }
    }
  },
  created() {
    this.role = this.rolesList[0];
  },
  i18n: {
    messages: {
      en: {
        formTitle: 'Add users to the workspace',
        emailLabel: 'Email',
        roleLabel: 'Role',
        createInvite: 'Send invite',
        roleViewerTip: 'The viewer will only be able to view your data.',
        roleUserTip: 'The user cannot delete the workspace or invite members.',
        roleAdminTip: 'The administrator will be able to delete this workspace and invite other members.',
      },
      ru: {
        formTitle: 'Добавить пользователей в пространство',
        emailLabel: 'Электронная почта',
        roleLabel: 'Роль',
        createInvite: 'Отправить приглашение',
        roleViewerTip: 'Наблюдатель сможет только посмотреть ваши данные.',
        roleUserTip: 'Пользователь не может удалить пространство и приглашать участников.',
        roleAdminTip: 'Администратор сможет удалить пространство и пригласить других участников.',
      }
    }
  }
}
</script>
